import { OctopusPurpleLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  avatar: string | null
}

export const TeamAvatar: React.FC<Props> = ({ avatar }) => {
  if (!avatar) {
    return (
      <div className={clsJoin(css.image_accessory, css.logo_accessory)}>
        <OctopusPurpleLogo className={css.svg_icon} />
      </div>
    )
  }

  return <img alt="" className={css.image_accessory} src={avatar} />
}
